<template>
  <div class="block1"
       :class="{on:isIphoneX}">
    <img src="../assets/icon_.png"
         alt=""
         class="top_image">
    <img src="../assets/image_like.png"
         alt=""
         class="buttom_image">
    <p>
      <a target="_blank"
         href="https://apps.apple.com/cn/app/%E6%81%8B%E7%88%B1%E7%89%A9%E8%AF%AD/id1473975969?l=en"
         class="toIphone"
         :class="{anim:isAnim}"></a>
      <a target="_blank"
         href="http://tg-toutiao.tiduhn.cn/official"
         v-if="notInWx"
         class="toAndroid"
         :class="{anim:isAnim}"></a>
      <a target="_blank"
         @click="toBrowser"
         v-else
         href="javascript:void(0)"
         class="toAndroid"
         :class="{anim:isAnim}"></a>
    </p>
    <div class="pop-tips"
         v-if="isShow"
         style="display: block;">
      <img :src="imgTip"
           alt="">
    </div>

    <mobileFooter v-if="status=='index'"></mobileFooter>
  </div>
</template>
<script>
import MobileFooter from '../mobilComponents/mobilFooter'
export default {
  name: 'mobileblock1',
  props: ['isAnim', 'isIphoneX'],
  components: {
    MobileFooter
  },
  computed: {
    status () {
      console.log(this.$store.state.status);
      return this.$store.state.status;
    }
  },
  data () {
    return {
      browser: {
        versions: function () {
          var u = navigator.userAgent, app = navigator.appVersion;
          return {
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
            androidChrome: u.match(/Chrome\/([\d.]+)/),// android chrome
            iosChrome: u.match(/CriOS\/([\d.]+)/), // ios chrome
            iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            safari: u.indexOf('Safari') > -1 && u.indexOf("Chrome") < 1, //是否safari
            weixin: u.indexOf('MicroMessenger') > -1, //是否微信
            qq: u.indexOf('QQ') > -1//是否QQ
          };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      },
      isShow: false,
      imgTip: require('../assets/pop.png'),
      notInWx: true
    }
  },

  mounted () {
    if (this.browser.versions.weixin) {
      this.notInWx = false
    }


  },
  methods: {
    toBrowser () {
      this.isShow = true;
    }
  }

}
</script>

<style scoped>
.block1 {
  text-align: center;
  margin-top: 25%;
}
.block1.on {
  /* margin-top: 48%; */
}

.block1 img {
  display: inline-block;
  width: 76%;
}

.block1 img:first-child {
}

.toIphone,
.toAndroid {
  width: 150px;
  height: 56px;
  margin-top: 50px;
  overflow: hidden;
  display: inline-block;
  transition: all 0.8s ease-out;
}
.toIphone {
  background: url("../assets/iphone.png") no-repeat;
  background-size: 100%;
  margin-right: 10px;
}
.toAndroid {
  background: url("../assets/android.png") no-repeat;
  background-size: 100%;
}

.toIphone.anim,
.toAndroid.anim {
  margin-left: 2%;
  opacity: 1;
}

.toIphone:hover,
.toIphone:active {
  background: url("../assets/iphone_pressed.png") no-repeat;
  background-size: 100%;
}

.toAndroid:hover,
.toAndroid:active {
  background: url("../assets/android_pressed.png") no-repeat;
  background-size: 100%;
}
.img-right {
  height: 500px;
  margin: 12% -700px 0 0;
  float: right;
  transition: all 1s ease-out;
}
.img-right.anim {
  margin-right: 2%;
}
.pop-tips {
  display: none;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
}
.pop-tips img {
  width: 18rem;
  position: absolute;
  top: 10px;
  right: 10px;
}

/* @media only screen and (width: 320px) and (height: 568px){ */
@media (max-width: 320px) {
  .buttom_image {
    width: 28.625rem;
    height: 15.4375rem;
  }
  .top_image {
    margin-top: -300px;
    width: 30.625rem;
    height: 2.0975rem;
  }
  .block1 > p {
    margin-top: -50px;
  }
  .toIphone {
    margin-right: 0;
  }
  .toIphone.anim,
  .toAndroid.anim {
    margin-left: 0;
  }
}

@media (min-width: 375px) {
  .buttom_image {
    width: 28.625rem;
    height: 20.4375rem;
  }
  .top_image {
    margin-top: -380px;
    width: 30.625rem;
    height: 2.0975rem;
  }
  .block1 > p {
    margin-top: -0px;
  }
  .toIphone {
    margin-right: 0;
  }
  .toIphone.anim,
  .toAndroid.anim {
    margin-left: 0;
  }
}

@media only screen and (width: 375px) and (height: 812px) {
  .buttom_image {
    width: 28.625rem;
    height: 25.4375rem;
  }
  .top_image {
    margin-top: -300px;
    width: 30.625rem;
    height: 2.0975rem;
  }
  .block1 > p {
    margin-top: 30px;
  }
  .toIphone {
    margin-right: 0;
  }
  .toIphone.anim,
  .toAndroid.anim {
    margin-left: 0;
  }
}

@media only screen and (width: 375px) and (height: 620px) {
  .buttom_image {
    width: 18.625rem;
    height:15.4375rem;
  }
  .top_image {
    margin-top: -300px;
    width: 30.625rem;
    height: 2.0975rem;
  }
  .block1 > p {
    margin-top: 10px;
  }
  .toIphone {
    margin-right: 0;
  }
  .toIphone.anim,
  .toAndroid.anim {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/mobilComponents/mobileblock1.vue